module.exports = __webpack_public_path__ + "static/sui-breadcrumb-basic-46220257db63a8b8f970aeba4406e771.png";